<booking-summary-mobile *ngIf="isMobile"></booking-summary-mobile>
<booking-summary-desktop *ngIf="!isMobile"></booking-summary-desktop>